import React from "react";
import { ENABLE_INCOMPLETE_FEATURES } from "@sonder/editor/source/core/constants";
import { KeyBinding } from "@sonder/editor/typings/editor";
import {
  FormatBold,
  Code as FormatCode,
  FormatItalic,
  FormatStrikethrough,
  FormatUnderlined,
} from "@sonder/ui/source/icons";

export interface InlineKeyBinding extends KeyBinding {
  style: InlineStyles;
  label: string;
  icon: React.FC;
  disabled: boolean;
}

export enum InlineStyles {
  Bold = "BOLD",
  Code = "CODE",
  Italic = "ITALIC",
  Underline = "UNDERLINE",
  StrikeThrough = "STRIKETHROUGH",
}

export const inlineKeyBindings = [
  {
    style: InlineStyles.Bold,
    label: "Bold (Cmd + B)",
    icon: FormatBold,
    keySelector: { command: true, keyCode: 66 },
    editorCommand: "bold",
    disabled: !ENABLE_INCOMPLETE_FEATURES,
  },
  {
    style: InlineStyles.Italic,
    label: "Italic (Cmd + I)",
    icon: FormatItalic,
    keySelector: { command: true, keyCode: 73 },
    editorCommand: "italic",
    disabled: !ENABLE_INCOMPLETE_FEATURES,
  },
  {
    style: InlineStyles.Code,
    label: "Code (Cmd + M)",
    icon: FormatCode,
    keySelector: { command: true, keyCode: 77 },
    editorCommand: "code",
    disabled: !ENABLE_INCOMPLETE_FEATURES,
  },
  {
    style: InlineStyles.Underline,
    label: "Underline (Cmd + U)",
    icon: FormatUnderlined,
    keySelector: { command: true, keyCode: 85 },
    editorCommand: "underline",
    // !TODO: Need to handle Draft <> HTML conversion before enabling
    disabled: true,
  },
  {
    style: InlineStyles.StrikeThrough,
    label: "Strike-through (Cmd + Shift + X)",
    icon: FormatStrikethrough,
    keySelector: { command: true, shift: true, keyCode: 88 },
    editorCommand: "strikethrough",
    // !TODO: Need to handle Draft <> HTML conversion before enabling
    disabled: true,
  },
].filter(({ disabled }) => !disabled) as InlineKeyBinding[];
